"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var InputGroupContext = /*#__PURE__*/_react["default"].createContext({});
exports.InputGroupContext = InputGroupContext;